import EmissionStatusBadge from './EmissionStatusBadge';
export default EmissionStatusBadge;
